import { FunctionComponent, useState } from 'react';
import { Box, Modal, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, createStyles, Theme, useTheme } from '@material-ui/core/styles';
import { ToolbarItem } from 'components/UI/Toolbar/ToolbarItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import { faCirclePlus, faList, faPuzzlePiece, faTag } from '@fortawesome/pro-regular-svg-icons';
import AddButton from '../UI/AddButton';
import { ActionsPopup } from 'components/UI/ActionsPopup/ActionsPopup';

interface Props {
    className?: string;
    onAddService: () => void;
    onAddAddOn: () => void;
    onAddProduct: () => void;
    onAddCustomItem: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            position: 'relative',
            display: 'flex',
            borderTop: '1px solid #D4D4D4'
        },
        icon: {
            cursor: 'pointer'
        },
        addService: {
            cursor: 'pointer',
            color: '#92B4A7',
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '27px',
            paddingTop: 10
        },
        leftSpace: {
            paddingLeft: '5px'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    })
);

export const AppointmentOptions: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [showMobile, setShowMobile] = useState(false);

    const serviceOption = (
        <ToolbarItem
            icon={faList}
            text="Primary Service"
            color="#222222"
            onClick={props.onAddService}
        />
    );

    const addOnOption = (
        <ToolbarItem
            icon={faPuzzlePiece}
            text="Add-on"
            color="#222222"
            onClick={props.onAddAddOn}
        />
    );

    const productOption = (
        <ToolbarItem
            icon={faTag}
            text="Product"
            color="#222222"
            onClick={props.onAddProduct}
        />
    );

    const customItemOption = (
        <ToolbarItem
            icon={faCirclePlus}
            text="Custom Item"
            color="#222222"
            onClick={props.onAddCustomItem}
        />
    );

    const mobileView = (
        <Modal
            open={true}
            aria-labelledby="simple-dialog-title"
            className={classes.modal}
        >
            <ActionsPopup
                actions={[
                    {
                        label: 'Primary Service',
                        icon: faList,
                        onClick: props.onAddService
                    },
                    {
                        label: 'Add-on',
                        icon: faPuzzlePiece,
                        onClick: props.onAddAddOn
                    },
                    {
                        label: 'Product',
                        icon: faTag,
                        onClick: props.onAddProduct
                    },
                    {
                        label: 'Custom Item',
                        icon: faCirclePlus,
                        onClick: props.onAddCustomItem
                    }
                ]}
                onClose={() => setShowMobile(false)}
            />
        </Modal>
    );

    return (
        <Box className={clsx(classes.container, props.className)}>
            {isMobile ? (
                <Box onClick={() => setShowMobile(true)}>
                    <Typography className={classes.addService}>
                        Add
                        {showMobile ? (
                            <FontAwesomeIcon
                                className={clsx(classes.addService, classes.leftSpace)}
                                icon={faChevronUp}
                            />
                        ) : (
                            <FontAwesomeIcon
                                className={clsx(classes.addService, classes.leftSpace)}
                                icon={faChevronDown}
                            />
                        )}
                    </Typography>
                </Box>
            ) : (
                <AddButton id="items_options">
                    {serviceOption}
                    {addOnOption}
                    {productOption}
                    {customItemOption}
                </AddButton>
            )}
            {showMobile && mobileView}
        </Box>
    );
};

export default AppointmentOptions;
